import React from "react";
import "../Styles/Testimonials.css";
 
const testimonials = [
  {
    id: 1,
    name: "Rahul Sharma",
    role: "Donor",
    message:
      "Pravartan has given me the opportunity to contribute to meaningful causes. I feel proud to support their mission.",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    id: 2,
    name: "Priya Verma",
    role: "Volunteer",
    message:
      "Volunteering with Pravartan has been life-changing. Their dedication to education and clean water is inspiring.",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    id: 3,
    name: "Amit Patel",
    role: "Beneficiary",
    message:
      "Thanks to Pravartan, my children now go to school regularly. We are forever grateful.",
    image: "https://randomuser.me/api/portraits/men/65.jpg",
  },
];

const Testimonials = () => {
  return (
    <div className="testimonials">
      <h1>What People Say(Testimonials)</h1>
      <div className="testimonial-list">
        {testimonials.map((t) => (
          <div className="testimonial-card" key={t.id}>
            <img src={t.image} alt={t.name} className="testimonial-img" />
            <p className="testimonial-message">“{t.message}”</p>
            <h3>{t.name}</h3>
            <span className="testimonial-role">{t.role}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
